var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input',_vm._g(_vm._b({class:_vm.$style.input,attrs:{"type":_vm.type},on:{"input":function($event){return _vm.$emit('update', $event.target.value)}}},'b-input',
    _vm.$attrs
    // https://vuejs.org/v2/guide/components-props.html#Disabling-Attribute-Inheritance
  ,false),
    _vm.$listeners
    // https://vuejs.org/v2/guide/components-custom-events.html#Binding-Native-Events-to-Components
  ))}
var staticRenderFns = []

export { render, staticRenderFns }